module.exports = __webpack_public_path__ + "img/icon3.eb669830.png";